/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncomingFriendRequest
 */
export interface IncomingFriendRequest {
    /**
     * User ID who sent the request
     * @type {string}
     * @memberof IncomingFriendRequest
     */
    odId: string;
    /**
     * Sender's nickname from their profile
     * @type {string}
     * @memberof IncomingFriendRequest
     */
    nickname?: string;
    /**
     * Sender's Discord username (fallback)
     * @type {string}
     * @memberof IncomingFriendRequest
     */
    discordUsername?: string;
    /**
     * Sender's avatar URL
     * @type {string}
     * @memberof IncomingFriendRequest
     */
    avatarUrl?: string;
    /**
     * When the request was sent (timestamp)
     * @type {number}
     * @memberof IncomingFriendRequest
     */
    requestedAt?: number;
}

/**
 * Check if a given object implements the IncomingFriendRequest interface.
 */
export function instanceOfIncomingFriendRequest(value: object): value is IncomingFriendRequest {
    if (!('odId' in value) || value['odId'] === undefined) return false;
    return true;
}

export function IncomingFriendRequestFromJSON(json: any): IncomingFriendRequest {
    return IncomingFriendRequestFromJSONTyped(json, false);
}

export function IncomingFriendRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncomingFriendRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'odId': json['odId'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'discordUsername': json['discordUsername'] == null ? undefined : json['discordUsername'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'requestedAt': json['requestedAt'] == null ? undefined : json['requestedAt'],
    };
}

export function IncomingFriendRequestToJSON(json: any): IncomingFriendRequest {
    return IncomingFriendRequestToJSONTyped(json, false);
}

export function IncomingFriendRequestToJSONTyped(value?: IncomingFriendRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'odId': value['odId'],
        'nickname': value['nickname'],
        'discordUsername': value['discordUsername'],
        'avatarUrl': value['avatarUrl'],
        'requestedAt': value['requestedAt'],
    };
}

